import "./App.css";
import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { LocaleProvider } from "providers/LocaleProvider";
import AuthProvider from "providers/AuthProvider";
import Layout from "containers/Layout";
import Login from "containers/Login";
import { ChakraProvider } from "@chakra-ui/react";

const Router = BrowserRouter as unknown as React.FC<React.PropsWithChildren>;

function App() {
  return (
    <ChakraProvider>
      <LocaleProvider>
        <AuthProvider>
          <Router>
            <Route path="/login" exact>
              <Login />
            </Route>
            <Layout />
          </Router>
        </AuthProvider>
      </LocaleProvider>
    </ChakraProvider>
  );
}

export default App;
